
import React, { useEffect, useRef } from 'react';
import TaskBlock from '../TaskBlock/TaskBlock';

const ChatMessageOverlay = ({ message, children, index }) => {
  const bottom = useRef(null);
  useEffect(() => {
    bottom.current?.scrollIntoView({ behavior: "smooth", block: "end" })
  }, []);
  return (
    <div
      key={index}
      className={`chat__message-box ${message.user === "bot" ? "bot__message-box" : "user__message-box"
        }`}
    >
      <div
        className={`chat-message ${message.user === "bot" ? "bot-message" : "user-message"
          }`}
      >
        {children}
       
      </div>
      {
         message.user === "bot" && message.hasTask && (
            <TaskBlock task={message.task} />
          )
        }
      <div ref={bottom}></div>
    </div>
  );
};

export default ChatMessageOverlay;